import React from 'react'
import styles from './CheckoutBar.module.css'

/* Mirrors RecommendedPlan's continueBar (avatar + label/amount + action arrow),
   with the "businesses onboarded" line below. Positioning is handled by the
   page's fixed footer, so this bar itself is not fixed. */
const CheckoutBar = ({
  avatar = '/svg/receptionist_profile.png',
  label,
  amount,
  buttonText,
  onClick,
}) => (
  <div className={styles.continueBar}>
    <button type="button" className={styles.continueBtn} onClick={onClick}>
      <span className={styles.continueAvatar}>
        <img src={avatar} alt="" />
      </span>
      <span className={styles.continueLeft}>
        <span className={styles.continueLabel}>{label}</span>
        <span className={styles.continuePlan}>{amount}</span>
      </span>
      <span className={styles.continueAction}>
        {buttonText} <span className={styles.continueArrow}>→</span>
      </span>
    </button>

    <p className={styles.stripeFoot}>
      <span className={styles.stripeLock}>🔒</span>
      <span className={styles.stripeWord}>stripe</span> Secure checkout. Cancel anytime.
    </p>
  </div>
)

export default CheckoutBar
